/* global window */
/* eslint react/no-danger: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import { getAppConfig } from '../../../helpers/utils';
import css from '../index.scss';
import Button from '../../button/index';
import { DARK } from '../../button/variants';
import messages from '../messages';
import PortalCommunication from '../../../portal-comms';

const ExtendResultInfo = (props) => {
    const {
        extendResultInfo,
        onProceedExtendResultRequest,
        yearGroups,
        extendingResultsStatusType,
        currentAcademicYear,
        intl,
        showOkButton
    } = props;

    const config = getAppConfig();
    const extendInfoHtml = config ? config.ExtendResultInfoContent : '';

    const infoView = extendingResultsStatusType === 'IsExtendable' && extendResultInfo ? (<div className={css.infoContainer}>
        <div className={css.infoHeading}>{` ${intl.formatMessage(messages.startFresh)} ${currentAcademicYear - 1}`}</div>
        <div className={css.infoContent}>
            <div dangerouslySetInnerHTML={{ __html: extendInfoHtml }} />
        </div>
        <div className={css.extendInfoFooter}>
            <Button
                containerClassName="back-button"
                handleOnClick={() => { PortalCommunication.navigateToLandingScreen('Rollover'); }}
                hidden={showOkButton}
                label={intl.formatMessage(messages.back)}
                variant={DARK} />
            <Button
                containerClassName="back-button"
                handleOnClick={onProceedExtendResultRequest}
                hidden={!showOkButton}
                label={intl.formatMessage(messages.ok)}
                variant={DARK} />
            <Button
                containerClassName="proceed-button"
                disabled={!(yearGroups.length > 0)}
                handleOnClick={onProceedExtendResultRequest}
                hidden={showOkButton}
                label={intl.formatMessage(messages.proceed)}
                variant={DARK} />
        </div>
    </div>) : <div />;

    return infoView;
};

ExtendResultInfo.propTypes = {
    intl: intlShape.isRequired,
    extendingResultsStatusType: PropTypes.string,
    onProceedExtendResultRequest: PropTypes.func,
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    currentAcademicYear: PropTypes.number,
    showOkButton: PropTypes.bool
};

export default injectIntl(styleable(css)(ExtendResultInfo));



// WEBPACK FOOTER //
// ./app/components/extend-result/pages/extend-info.js